import { InputProps } from "@/src/types/input.type";
import { useState } from "react";
import { Dropdown, Form, InputGroup } from "react-bootstrap";

export default function DropdownInput({
  className,
  value,
  options,
  onChanged,
  onBlur,
  readOnly=false
}:InputProps)
{
  const [isOpen, setIsOpen] = useState(false);

  const selectOption = (inputValue: string) => {
    const normalizedValue = inputValue.trim().toLowerCase();
    const selected = options?.find(([optionLabel, optionValue]) =>
      [String(optionLabel), String(optionValue)]
        .some((option) => option.trim().toLowerCase() === normalizedValue),
    );

    if (selected) onChanged?.(String(selected[1]));
  };

  return (
    <InputGroup className="w-auto d-flex align-items-stretch">
      <Form.Control
        className={[className, "flex-grow-1", "h-100", "rounded-end-0"].filter(Boolean).join(" ")}
        value={value ?? ""}
        readOnly={readOnly}
        onChange={(event) => selectOption(event.currentTarget.value)}
        onBlur={onBlur}
        onKeyDown={(event) => {
          if ((event.key === " " || event.key === "Spacebar") && !readOnly) {
            event.preventDefault();
            setIsOpen(true);
          }
        }}
      />
      <Dropdown
        className="h-100 d-flex"
        show={isOpen}
        onToggle={(nextShow) => setIsOpen(nextShow)}
        onSelect={(eventKey) => {
          selectOption(eventKey ?? "");
          setIsOpen(false);
        }}
      >
        <Dropdown.Toggle
          className="flex-shrink-0 d-flex align-items-center justify-content-center px-2 py-0"
          variant="outline-secondary"
          disabled={readOnly}
          tabIndex={-1}
          onKeyDown={(event) => {
            if (event.key === "Tab") {
              event.preventDefault();
            }
          }}
          style={{ maxHeight: "calc(1.5em + 0.75rem + 2px)" }}
        >
          <span aria-hidden="true">&nbsp;</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {options?.map(([optionLabel, optionValue], index) => (
            <Dropdown.Item key={index} eventKey={String(optionValue)}>
              {optionLabel}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </InputGroup>
  )
}
